var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "give",
    transform: "translate(0 3.986)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_288",
    "data-name": "Rectangle 288",
    width: 24,
    height: 24,
    transform: "translate(0 -3.986)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2851",
    "data-name": "Path 2851",
    d: "M.48,13.754A1.306,1.306,0,0,0,1.786,15.06H17.569a1.306,1.306,0,0,0,1.306-1.306V3.681H.48Z",
    transform: "translate(0 -0.302)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2852",
    "data-name": "Path 2852",
    d: "M17.57,15.54H1.786A1.788,1.788,0,0,1,0,13.754V3.681A.48.48,0,0,1,.48,3.2h18.4a.48.48,0,0,1,.48.48V13.754A1.788,1.788,0,0,1,17.57,15.54M.96,4.161v9.593a.826.826,0,0,0,.826.826H17.57a.827.827,0,0,0,.826-.826V4.161Z",
    transform: "translate(0 -0.302)",
    fill: "#414143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2853",
    "data-name": "Path 2853",
    d: "M17.57.48H1.786A1.306,1.306,0,0,0,.481,1.786V3.681H18.876V1.786A1.306,1.306,0,0,0,17.57.48",
    transform: "translate(0 -0.302)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2854",
    "data-name": "Path 2854",
    d: "M18.876,4.161H.48A.48.48,0,0,1,0,3.681v-1.9A1.788,1.788,0,0,1,1.786,0H17.57a1.788,1.788,0,0,1,1.786,1.785v1.9a.48.48,0,0,1-.48.48M.96,3.2H18.4V1.785A.827.827,0,0,0,17.57.96H1.786a.826.826,0,0,0-.826.825Z",
    transform: "translate(0 -0.302)",
    fill: "#414143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2855",
    "data-name": "Path 2855",
    d: "M18.876,12.237H11.689A.686.686,0,0,1,11,11.551V7.19a.687.687,0,0,1,.686-.687h7.187Z",
    transform: "translate(0 -0.302)",
    fill: "#0ff497"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2856",
    "data-name": "Path 2856",
    d: "M18.876,12.717H11.689a1.167,1.167,0,0,1-1.166-1.166V7.189a1.167,1.167,0,0,1,1.166-1.166h7.187a.48.48,0,0,1,.48.48v5.734a.48.48,0,0,1-.48.48M11.689,6.983a.206.206,0,0,0-.206.206v4.362a.207.207,0,0,0,.206.206H18.4V6.983Z",
    transform: "translate(0 -0.302)",
    fill: "#414143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2857",
    "data-name": "Path 2857",
    d: "M13.934,10.235H11.482a.986.986,0,0,1,0-1.973h4.147a4.817,4.817,0,0,1,2.323.6l.966.532a4.688,4.688,0,0,0,2.26.581h1.669a.674.674,0,0,1,.674.674v3.268a.674.674,0,0,1-.674.674H21.1a4.679,4.679,0,0,0-1.663.306l-2.486.944a4.8,4.8,0,0,1-1.71.314H9.657a.986.986,0,0,1,0-1.973h4.277",
    transform: "translate(0 -0.302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2858",
    "data-name": "Path 2858",
    d: "M15.242,16.634H9.657a1.467,1.467,0,0,1,0-2.933h4.277a.48.48,0,0,1,0,.96H9.657a.507.507,0,0,0,0,1.013h5.585a4.308,4.308,0,0,0,1.539-.283l2.486-.945A5.157,5.157,0,0,1,21.1,14.11h1.746a.193.193,0,0,0,.193-.194V10.648a.193.193,0,0,0-.193-.194h-1.67a5.18,5.18,0,0,1-2.49-.641l-.967-.532a4.342,4.342,0,0,0-2.091-.538H11.483a.507.507,0,1,0,0,1.013h2.451a.48.48,0,0,1,0,.96H11.483a1.466,1.466,0,1,1,0-2.933h4.146a5.3,5.3,0,0,1,2.554.657l.967.532a4.207,4.207,0,0,0,2.027.522h1.67A1.155,1.155,0,0,1,24,10.648v3.268a1.155,1.155,0,0,1-1.153,1.154H21.1a4.187,4.187,0,0,0-1.493.274l-2.485.945a5.284,5.284,0,0,1-1.881.345",
    transform: "translate(0 -0.302)",
    fill: "#414143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2859",
    "data-name": "Path 2859",
    d: "M13.934,10.235H9.657a.987.987,0,0,0,0,1.973h4.277",
    transform: "translate(0 -0.302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2860",
    "data-name": "Path 2860",
    d: "M13.934,12.688H9.657a1.466,1.466,0,0,1,0-2.932h4.277a.48.48,0,1,1,0,.959H9.657a.507.507,0,0,0,0,1.013h4.277a.48.48,0,0,1,0,.96",
    transform: "translate(0 -0.302)",
    fill: "#414143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2861",
    "data-name": "Path 2861",
    d: "M13.934,12.208H8.815a.986.986,0,0,0,0,1.973h5.119",
    transform: "translate(0 -0.302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2862",
    "data-name": "Path 2862",
    d: "M13.934,14.661H8.815a1.467,1.467,0,0,1,0-2.933h5.119a.48.48,0,0,1,0,.96H8.815a.507.507,0,0,0,0,1.013h5.119a.48.48,0,0,1,0,.96",
    transform: "translate(0 -0.302)",
    fill: "#414143"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGive);
export default __webpack_public_path__ + "static/media/give.855a8ec5c6e010065a2e2a7b4aeba589.svg";
export { ForwardRef as ReactComponent };